<template>
  <div>
    <el-form class="p-1" :model="data.lastNode" status-icon label-width="80px">
      <el-form-item label="办理" prop="selectType" label-width="40px">
        <el-radio-group v-model="data.form.selectType">
          <el-radio :label="0">转新舆情</el-radio>
          <el-radio :label="-1">存档备查</el-radio>
          <el-radio :label="-2">撤销重报</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="相关单位">
        <el-select :disabled="data.form.selectType != -1" class="tel" v-model="data.form.transferUnitId"
          placeholder="请选择单位" clearable filterable popper-append-to-body>
          <el-option v-for="unit in data.units" :key="unit.id" :label="unit.name" :value="unit.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="办理说明">
        <el-input type="textarea" :rows="3" v-model="data.form.message" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "GDanAudit",
  props: ["pstId"],
  data() {
    return {
      data: {
        user: "",
        statusName: "",
        pstTypeName: "",
        units: [], //单位数据
        pst: {
          id: "",
          unitName: "",
        },
        nodes: "",
        lastNode: {
          id: "",
          isSucces: false,
          lastTime: "",
          nodeContent: "",
          nodeMessage: "",
          pstId: "",
          pstType: 1,
          status: -1,
          transferUnitId: "",
          transferUnitName: "",
          unitId: "",
          unitName: "",
          userId: "",
          userName: "",
          uploadCount: 0,
        },
        form: {
          selectType: -1,
          message: "",
          transferUnitId: "",
        },
      },
    };
  },
  created() {
    this.data.pst.id = this.pstId;
    this.data.user = this.pstApi.getUserData();
    this.getUnits(); //读取所有单位信息
    this.getPst(); //读取舆情  信息
  },
  methods: {
    getUnits() {
      this.data.units = [];
      this.userApi.getUnitAll().then((res) => {
        var data = res.data;
        this.data.units = this.data.units.concat(data);
      });
    },
    //读取舆情信息
    getPst() {
      let pstId = this.pstId;
      this.pstApi
        .getPstInfo(pstId)
        .then((res) => {
          var data = res.data;
          this.data.pst = data;
          //console.log(data);
          this.data.nodes = data.nodeInfos.filter(
            (node) => node.isSucces == true
          );
          var transferNodes = data.nodeInfos.filter(
            (node) => node.isSucces == false
          );
          //console.log(transferNodes)
          if (transferNodes.length > 0) {
            this.data.lastNode = transferNodes[0];
          }
          this.data.form.selectType = this.data.lastNode.status;
          this.data.form.message = this.data.lastNode.nodeMessage;
          this.data.lastNode.unitId = this.data.user.unitId;
          this.data.lastNode.unitName = this.data.user.unitName;
          this.data.lastNode.userId = this.data.user.userId;
          this.data.lastNode.userName = this.data.user.name;

          this.data.statusName = this.pstApi.getStatusTransferTitle(
            this.data.pst.status
          );
          //console.log('title:',this.data.statusName)
          this.data.pstTypeName = this.pstApi.getPstTypeName(
            this.data.pst.pstType
          );
          //this.getUnits(); //读取所有单位信息
        })
        .catch((err) => {
          this.$toast("读取失败");
        });
    },
    //负面舆情审核
    formSubmit(buttonType) {
      let pstId = this.data.pst.id;
      let status = this.data.form.selectType;
      let message = this.data.form.message;
      var transferUnId = "00000000-0000-0000-0000-000000000000";
      if (status == -1 && this.data.form.transferUnitId != "") {
        transferUnId = this.data.form.transferUnitId;
      }
      // //0-保存 1-提交
      let submitType = buttonType;
      if (message == "" && submitType == 1) {
        if (status == 0) {
          message = "转为新舆情";
        } else if (status == -1) {
          message = "存档备查";
        } else if (status == -2) {
          message = "请重新上报";
        }
      }
      // if(status==-1 && transferUnId=="00000000-0000-0000-0000-000000000000"){
      //   this.$toast("存档备查,单位不能为空");
      // }
      this.pstApi
        .negativeAudit(pstId, message, submitType, status, transferUnId)
        .then(() => {
          if (status == -2) {
            this.$toast("撤销成功");
          } else if (buttonType == 1) {
            if (status == -1) {
              this.$toast("收藏成功");
            } else {
              this.$toast("审核成功");
            }
          } else {
            this.$toast("保存成功");
          }
          //success
          this.$emit("success");
        })
        .catch(() => {
          this.$toast("审核失败");
        });
    },
    handleClick: function () {
      this.$emit("click");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-radio {
  margin-right: 5px;
}

/deep/.el-select-dropdown {
  // position: absolute;
  z-index: 99999;
}
</style>